export default class Constants {

    static get CERTIFICATE_API_URL() {
        return "/certificate/many";
    }

    static get MAGAZINE_PAGE_API_URL() {
        return "/magazine-page/many";
    }

    static get OIDC_AUTHORITY() {
        return 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_Prm90vypV';
    }

    static get OIDC_CLIENT_ID() {
        return '6m8pa9gle1i7pb263kli2c0jmu';
    }

    static get OIDC_REDIRECT_URL() {
        return 'https://certificates.iconica.art';
    }

    static get MAX_ELEMENTS_PER_REQUEST() {
        return 4;
    }

    static get MAX_POST_REQUEST_SIZE_IN_BYTES() {
        return 2048 * 2048;
    }

    static get CONTENT_TYPE_ZIP() {
        return "application/zip";
    }

    static get CONTENT_TYPE_JSON() {
        return "application/json";
    }

    static get ELEMENT_TEXT() {
        return "TextElement";
    }

    static get ELEMENT_IMAGE() {
        return "ImageElement";
    }

    static get ELEMENT_SHADOW() {
        return "ShadowElement";
    }

    static get FONT_STYLE_BOLD() {
        return 1;
    }

    static get FONT_STYLE_ITALIC() {
        return 2;
    }

    static get FONT_STYLE_UNDERLINE() {
        return 4;
    }

    static get STYLE_ALIGN_LEFT() {
        return 8;
    }

    static get STYLE_ALIGN_CENTER() {
        return 16;
    }

    static get STYLE_ALIGN_RIGHT() {
        return 32;
    }

    static get STYLE_VERTICAL_ALIGN_TOP() {
        return 64;
    }

    static get STYLE_VERTICAL_ALIGN_CENTER() {
        return 128;
    }

    static get STYLE_VERTICAL_ALIGN_BOTTOM() {
        return 256;
    }

    static get NOTIFICATION_ERROR() {
        return {
            severity: 'error',
            autoHideDuration: 30000,
        }
    }

    static get NOTIFICATION_WARNING() {
        return {
            severity: 'warning',
            autoHideDuration: 10000,
        }
    }

    static get NOTIFICATION_INFO() {
        return {
            severity: 'info',
            autoHideDuration: 10000,
        }
    }

    static get NOTIFICATION_SUCCESS() {
        return {
            severity: 'success',
            autoHideDuration: 10000,
        }
    }


    static get DEFAULT_SHADOW_ANGLE() {
        return 315;
    }

    static get DEFAULT_FONT_COLOR() {
        return "#2c0202";
    }

    static get DEFAULT_FONT() {
        return Constants.FONT_FAMILIES[0].name;
    }

    static get DEFAULT_PAGE_MAKER_FONT() {
        return "Dream Orphans";
    }

    static get FONT_FAMILIES() {
        return [
            { name: 'Avenir Next' },
            { name: 'Avenir Next Demi Bold' },
            { name: 'Avenir Next Heavy' },
            { name: 'Avenir Next Medium' },
            { name: 'Avenir Next Ultra Light' },
            { name: 'Beteckna' },
            { name: 'BetecknaGS' },
            { name: 'BetecknaGSCondensed' },
            { name: 'Bitstream Vera Sans' },
            { name: 'Bitstream Vera Sans Mono:spacing=100' },
            { name: 'Bitstream Vera Serif' },
            { name: 'Cairo' },
            { name: 'Cairo,Cairo Black' },
            { name: 'Cairo,Cairo ExtraBold' },
            { name: 'Cairo,Cairo ExtraLight' },
            { name: 'Cairo,Cairo Light' },
            { name: 'Cairo,Cairo Medium' },
            { name: 'Cairo,Cairo SemiBold' },
            { name: 'Caliban' },
            { name: 'Caslon' },
            { name: 'Cormorant Garamond Regular' },
            { name: 'Cormorant Garamond Medium' },
            { name: 'Cormorant Garamond SemiBold' },
            { name: 'Cubefont' },
            { name: 'Cupola' },
            { name: 'DejaVu Sans' },
            { name: 'DejaVu Sans Mono:spacing=100' },
            { name: 'DejaVu Serif' },
            { name: 'DM Sans' },
            { name: 'DM Sans 18pt' },
            { name: 'DM Sans 18pt,DM Sans 18pt Black' },
            { name: 'DM Sans 18pt,DM Sans 18pt ExtraBold' },
            { name: 'DM Sans 18pt,DM Sans 18pt ExtraLight' },
            { name: 'DM Sans 18pt,DM Sans 18pt Light' },
            { name: 'DM Sans 18pt,DM Sans 18pt Medium' },
            { name: 'DM Sans 18pt,DM Sans 18pt SemiBold' },
            { name: 'DM Sans 18pt,DM Sans 18pt Thin' },
            { name: 'DM Sans 24pt' },
            { name: 'DM Sans 24pt,DM Sans 24pt Black' },
            { name: 'DM Sans 24pt,DM Sans 24pt ExtraBold' },
            { name: 'DM Sans 24pt,DM Sans 24pt ExtraLight' },
            { name: 'DM Sans 24pt,DM Sans 24pt Light' },
            { name: 'DM Sans 24pt,DM Sans 24pt Medium' },
            { name: 'DM Sans 24pt,DM Sans 24pt SemiBold' },
            { name: 'DM Sans 24pt,DM Sans 24pt Thin' },
            { name: 'DM Sans 36pt' },
            { name: 'DM Sans 36pt,DM Sans 36pt Black' },
            { name: 'DM Sans 36pt,DM Sans 36pt ExtraBold' },
            { name: 'DM Sans 36pt,DM Sans 36pt ExtraLight' },
            { name: 'DM Sans 36pt,DM Sans 36pt Light' },
            { name: 'DM Sans 36pt,DM Sans 36pt Medium' },
            { name: 'DM Sans 36pt,DM Sans 36pt SemiBold' },
            { name: 'DM Sans 36pt,DM Sans 36pt Thin' },
            { name: 'DM Sans,DM Sans 9pt' },
            { name: 'DM Sans,DM Sans Black' },
            { name: 'DM Sans,DM Sans ExtraBold' },
            { name: 'DM Sans,DM Sans ExtraLight' },
            { name: 'DM Sans,DM Sans Light' },
            { name: 'DM Sans,DM Sans Medium' },
            { name: 'DM Sans,DM Sans SemiBold' },
            { name: 'DM Sans,DM Sans Thin' },
            { name: 'Dream Orphans' },
            { name: 'Frizzed B' },
            { name: 'RK' },
            { name: 'GFS Didot Regular' },
            { name: 'GWMonospace' },
            { name: 'James Fajardo' },
            { name: 'Janda Stylish Script' },
            { name: 'Jim Nightshade' },
            { name: 'Josefin Sans' },
            { name: 'Josefin Sans Light' },
            { name: 'Josefin Sans SemiBold' },
            { name: 'Josefin Sans Thin' },
            { name: 'Josephin' },
            { name: 'Junge' },
            { name: 'Justus' },
            { name: 'K22 Spotty Face' },
            { name: 'Kaiti SC,楷體-簡,楷体-简' },
            { name: 'Kaiti TC,楷體-繁,楷体-繁' },
            { name: 'Kelly Slab' },
            { name: 'Kenteken' },
            { name: 'Khand' },
            { name: 'Khand,Khand Bold' },
            { name: 'Khand,Khand Light' },
            { name: 'Khand,Khand Medium' },
            { name: 'Khand,Khand Semibold' },
            { name: 'Klee,クレー,Klee Demibold,クレー デミボールド' },
            { name: 'Klee,クレー,Klee Medium,クレー ミディアム' },
            { name: 'KoHo' },
            { name: 'KoHo ExtraLight' },
            { name: 'KoHo ExtraLight Italic' },
            { name: 'KoHo Light' },
            { name: 'KoHo Light Italic' },
            { name: 'KoHo Medium' },
            { name: 'KoHo Medium Italic' },
            { name: 'KoHo Italic' },
            { name: 'KoHo Bold' },
            { name: 'KoHo Bold Italic' },
            { name: 'KoHo SemiBold' },
            { name: 'KoHo SemiBold Italic' },
            { name: 'Komikazoom' },
            { name: 'Kontor' },
            { name: 'Kozuka Gothic Pr6N,小塚ゴシック Pr6N,Kozuka Gothic Pr6N B,小塚ゴシック Pr6N B' },
            { name: 'Kozuka Gothic Pr6N,小塚ゴシック Pr6N,Kozuka Gothic Pr6N EL,小塚ゴシック Pr6N EL' },
            { name: 'Kozuka Gothic Pr6N,小塚ゴシック Pr6N,Kozuka Gothic Pr6N H,小塚ゴシック Pr6N H' },
            { name: 'Kozuka Gothic Pr6N,小塚ゴシック Pr6N,Kozuka Gothic Pr6N L,小塚ゴシック Pr6N L' },
            { name: 'Kozuka Gothic Pr6N,小塚ゴシック Pr6N,Kozuka Gothic Pr6N M,小塚ゴシック Pr6N M' },
            { name: 'Kozuka Gothic Pr6N,小塚ゴシック Pr6N,Kozuka Gothic Pr6N R,小塚ゴシック Pr6N R' },
            { name: 'Kozuka Gothic Pro,小塚ゴシック Pro,Kozuka Gothic Pro B,小塚ゴシック Pro B' },
            { name: 'Kozuka Gothic Pro,小塚ゴシック Pro,Kozuka Gothic Pro EL,小塚ゴシック Pro EL' },
            { name: 'Kozuka Gothic Pro,小塚ゴシック Pro,Kozuka Gothic Pro H,小塚ゴシック Pro H' },
            { name: 'Kozuka Gothic Pro,小塚ゴシック Pro,Kozuka Gothic Pro L,小塚ゴシック Pro L' },
            { name: 'Kozuka Gothic Pro,小塚ゴシック Pro,Kozuka Gothic Pro M,小塚ゴシック Pro M' },
            { name: 'Kozuka Gothic Pro,小塚ゴシック Pro,Kozuka Gothic Pro R,小塚ゴシック Pro R' },
            { name: 'Kozuka Mincho Pr6N,小塚明朝 Pr6N,Kozuka Mincho Pr6N B,小塚明朝 Pr6N B' },
            { name: 'Kozuka Mincho Pr6N,小塚明朝 Pr6N,Kozuka Mincho Pr6N EL,小塚明朝 Pr6N EL' },
            { name: 'Kozuka Mincho Pr6N,小塚明朝 Pr6N,Kozuka Mincho Pr6N H,小塚明朝 Pr6N H' },
            { name: 'Kozuka Mincho Pr6N,小塚明朝 Pr6N,Kozuka Mincho Pr6N L,小塚明朝 Pr6N L' },
            { name: 'Kozuka Mincho Pr6N,小塚明朝 Pr6N,Kozuka Mincho Pr6N M,小塚明朝 Pr6N M' },
            { name: 'Kozuka Mincho Pr6N,小塚明朝 Pr6N,Kozuka Mincho Pr6N R,小塚明朝 Pr6N R' },
            { name: 'Kozuka Mincho Pro,小塚明朝 Pro,Kozuka Mincho Pro B,小塚明朝 Pro B' },
            { name: 'Kozuka Mincho Pro,小塚明朝 Pro,Kozuka Mincho Pro EL,小塚明朝 Pro EL' },
            { name: 'Kozuka Mincho Pro,小塚明朝 Pro,Kozuka Mincho Pro H,小塚明朝 Pro H' },
            { name: 'Kozuka Mincho Pro,小塚明朝 Pro,Kozuka Mincho Pro L,小塚明朝 Pro L' },
            { name: 'Kozuka Mincho Pro,小塚明朝 Pro,Kozuka Mincho Pro M,小塚明朝 Pro M' },
            { name: 'Kozuka Mincho Pro,小塚明朝 Pro,Kozuka Mincho Pro R,小塚明朝 Pro R' },
            { name: 'Lancelot' },
            { name: 'Lantinghei SC,蘭亭黑-簡,兰亭黑-简' },
            { name: 'Lantinghei TC,蘭亭黑-繁,兰亭黑-繁' },
            { name: 'LaserMetal' },
            { name: 'League Spartan Thin' },
            { name: 'League Spartan ExtraLight' },
            { name: 'League Spartan Light' },
            { name: 'League Spartan Regular' },
            { name: 'League Spartan Medium' },
            { name: 'League Spartan SemiBold' },
            { name: 'League Spartan Bold' },
            { name: 'League Spartan ExtraBold' },
            { name: 'League Spartan Black' },
            { name: 'Letter Gothic Std:spacing=100' },
            { name: 'Liberation Mono:spacing=100' },
            { name: 'Liberation S' },
            { name: 'ans' },
            { name: 'Liberation Sans Narrow' },
            { name: 'Liberation Serif' },
            { name: 'Libian SC,隸變-簡,隶变-简' },
            { name: 'LiHei Pro' },
            { name: 'Lintel' },
            { name: 'LiSong Pro' },
            { name: 'Lithos Pro,Lithos Pro Regular' },
            { name: 'Lobster 1.4' },
            { name: 'Lora' },
            { name: 'Lowvetica' },
            { name: 'LT Oksana' },
            { name: 'Luxi Mono' },
            { name: 'Luxi Mono:spacing=100' },
            { name: 'Luxi Sans' },
            { name: 'Luxi Serif' },
            { name: 'Magenta' },
            { name: 'Magenta Flower' },
            { name: 'Magnolia Sky' },
            { name: 'Margueritas' },
            { name: 'Market Deco' },
            { name: 'Martel' },
            { name: 'Martel,Martel DemiBold' },
            { name: 'Martel,Martel ExtraBold' },
            { name: 'Martel,Martel Heavy' },
            { name: 'Martel,Martel Light' },
            { name: 'Martel,Martel UltraLight' },
            { name: 'Master Of Break' },
            { name: 'Mattilda' },
            { name: 'MAWNS Serif' },
            { name: 'Merriweather' },
            { name: 'Merriweather,Merriweather Black' },
            { name: 'Merriweather,Merriweather Light' },
            { name: 'Meshes' },
            { name: 'Mesquite Std' },
            { name: 'Minion Pro' },
            { name: 'Minion Pro,Minion Pro Cond' },
            { name: 'Minion Pro,Minion Pro Med' },
            { name: 'Minion Pro,Minion Pro SmBd' },
            { name: 'MKorsair' },
            { name: 'Mochiy Pop P One' },
            { name: 'Monofonto:spacing=100' },
            { name: 'Montserrat' },
            { name: 'Montserrat,Montserrat Black' },
            { name: 'Montserrat,Montserrat ExtraBold' },
            { name: 'Montserrat,Montserrat ExtraLight' },
            { name: 'Montserrat,Montserrat Light' },
            { name: 'Montserrat,Montserrat Medium' },
            { name: 'Montserrat,Montserrat SemiBold' },
            { name: 'Montserrat,Montserrat Thin' },
            { name: 'Moon Flower' },
            { name: 'Moon Flower Bold' },
            { name: 'Mossy' },
            { name: 'Mouse Deco' },
            { name: 'Movie Letters' },
            { name: 'Msn Weird' },
            { name: 'MTF Cool Kid' },
            { name: 'Myriad Arabic,Myriad عربي' },
            { name: 'Myriad Hebrew,Myriad עברית' },
            { name: 'Myriad Pro' },
            { name: 'Myriad Pro,Myriad Pro Cond' },
            { name: 'Myriad Pro,Myriad Pro Light' },
            { name: 'Myriad Web Pro' },
            { name: 'Nanum Brush Script,나눔손글씨 붓' },
            { name: 'Nanum Gothic,나눔고딕' },
            { name: 'Nanum Gothic,나눔고딕,NanumGothic ExtraBold,나눔고딕 ExtraBold' },
            { name: 'Nanum Myeongjo,나눔명조' },
            { name: 'Nanum Myeongjo,나눔명조,NanumMyeongjoExtraBold,나눔명조 ExtraBold' },
            { name: 'Nanum Pen Script,나눔손글씨 펜' },
            { name: 'New Cicle' },
            { name: '.New York' },
            { name: 'Nilland' },
            { name: 'Nilland-Black' },
            { name: 'Nilland-ExtraBold' },
            { name: 'Nilland-SmallCaps' },
            { name: 'Noir-et-Blanc' },
            { name: 'Nonserif' },
            { name: 'Northern Lights' },
            { name: 'Noto Serif JP' },
            { name: 'Noto Serif JP,Noto Serif JP Black' },
            { name: 'Noto Serif JP,Noto Serif JP ExtraLight' },
            { name: 'Noto Serif JP,Noto Serif JP Light' },
            { name: 'Noto Serif JP,Noto Serif JP Medium' },
            { name: 'Noto Serif JP,Noto Serif JP SemiBold' },
            { name: 'Nouvelle Vague' },
            { name: 'No Way Back' },
            { name: 'Nueva Std' },
            { name: 'Nueva Std,Nueva Std Cond' },
            { name: 'OCR A Std:spacing=100' },
            { name: 'Octin Sports,Octin Sports Rg' },
            { name: 'Odin Rounded' },
            { name: 'Old Standard TT' },
            { name: 'Olympicons' },
            { name: 'Olympicons 2' },
            { name: 'OpenSymbol' },
            { name: 'Orator Std:spacing=100' },
            { name: 'Overpass' },
            { name: 'Overpass,Overpass Black' },
            { name: 'Overpass,Overpass ExtraBold' },
            { name: 'Overpass,Overpass ExtraLight' },
            { name: 'Overpass,Overpass Light' },
            { name: 'Overpass,Overpass SemiBold' },
            { name: 'Overpass,Overpass Thin' },
            { name: 'Ovo' },
            { name: 'Playfair Display' },
            { name: 'Playfair Display,Playfair Display Black' },
            { name: 'Playfair Display SC' },
            { name: 'Playfair Display SC,Playfair Display SC Black' },
            { name: 'Podkova' },
            { name: 'Podkova,Podkova ExtraBold' },
            { name: 'Podkova,Podkova Medium' },
            { name: 'Podkova,Podkova SemiBold' },
            { name: 'Poplar Std' },
            { name: 'Prestige Elite Std:spacing=100' },
            { name: 'Quicksand' },
            { name: 'Quicksand,Quicksand Light' },
            { name: 'Quicksand,Quicksand Medium' },
            { name: 'Rajdhani' },
            { name: 'Rajdhani,Rajdhani Light' },
            { name: 'Rajdhani,Rajdhani Medium' },
            { name: 'Rajdhani,Rajdhani SemiBold' },
            { name: 'y Medium' },
            { name: 'Raleway' },
            { name: 'Raleway Medium' },
            { name: 'Raleway Black' },
            { name: 'Raleway ExtraLight' },
            { name: 'Raleway SemiBold' },
            { name: 'Raleway ExtraBold' },
            { name: 'Raleway Thin' },
            { name: 'Raleway Light' },
            { name: 'Rasa' },
            { name: 'Rasa,Rasa Light' },
            { name: 'Rasa,Rasa Medium' },
            { name: 'Rasa,Rasa SemiBold' },
            { name: 'Ribbons and banners' },
            { name: 'Roboto' },
            { name: 'Roboto,Roboto Black' },
            { name: 'Roboto,Roboto Light' },
            { name: 'Roboto,Roboto Medium' },
            { name: 'Roboto,Roboto Thin' },
            { name: 'Rokkitt' },
            { name: 'Rokkitt Black' },
            { name: 'Rokkitt ExtraBold' },
            { name: 'Rokkitt ExtraLight' },
            { name: 'Rokkitt Light' },
            { name: 'Rokkitt Medium' },
            { name: 'Rokkitt SemiBold' },
            { name: 'Rokkitt Thin' },
            { name: 'Round About' },
            { name: 'Rurable Personal Use Only' },
            { name: 'Sagitarius' },
            { name: 'Scriptina' },
            { name: 'Scriptina - Alternates' },
            { name: 'Sneakers' },
            { name: 'Source Sans Pro' },
            { name: 'Source Sans Pro,Source Sans Pro Black' },
            { name: 'Source Sans Pro,Source Sans Pro ExtraLight' },
            { name: 'Source Sans Pro,Source Sans Pro Light' },
            { name: 'Source Sans Pro,Source Sans Pro Semibold' },
            { name: 'Spartan' },
            { name: 'Spartan,Spartan Black' },
            { name: 'Spartan,Spartan ExtraBold' },
            { name: 'Spartan,Spartan ExtraLight' },
            { name: 'Spartan,Spartan Light' },
            { name: 'Spartan,Spartan Medium' },
            { name: 'Spartan,Spartan SemiBold' },
            { name: 'Spartan,Spartan Thin' },
            { name: 'Spectral SC' },
            { name: 'Spectral SC,Spectral SC ExtraBold' },
            { name: 'Spectral SC,Spectral SC ExtraLight' },
            { name: 'Spectral SC,Spectral SC Light' },
            { name: 'Spectral SC,Spectral SC Medium' },
            { name: 'Spectral SC,Spectral SC SemiBold' },
            { name: 'STKaiti' }
        ];
    }

}
